import LearnPageLayout from "@/components/LearnPageLayout";
import { saintMiami } from "./learnDataSaintMiami";

export default function SaintMiamiPage() {
  return (
    <LearnPageLayout
      title={saintMiami.title}
      description={saintMiami.description}
      canonical={saintMiami.canonical}
      h1={saintMiami.h1}
      breadcrumbLabel={saintMiami.breadcrumbLabel}
      crumbs={saintMiami.crumbs}
      shortAnswer={saintMiami.shortAnswer}
      keyTakeaways={saintMiami.keyTakeaways}
      sections={saintMiami.sections}
      faqs={saintMiami.faqs}
      sources={saintMiami.sources}
      schemaJson={saintMiami.schemaJson}
      relatedLinks={saintMiami.relatedLinks}
      reviewBlock={saintMiami.reviewBlock}
      toc={saintMiami.toc}
      safetyBlock={saintMiami.safetyBlock}
      trademarkFooter={saintMiami.trademarkFooter}
      ctaBand={saintMiami.ctaBand}
    />
  );
}
